import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const [timeLeft, setTimeLeft] = useState({ h: 48, m: 0, s: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return { ...prev, s: prev.s - 1 };
        if (prev.m > 0) return { ...prev, m: prev.m - 1, s: 59 };
        if (prev.h > 0) return { ...prev, h: prev.h - 1, m: 59, s: 59 };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative pt-40 pb-20 px-6 min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Dynamic Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-1/4 -left-20 w-[500px] h-[500px] bg-fuchsia-600/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 -right-20 w-[500px] h-[500px] bg-cyan-600/10 rounded-full blur-[120px]" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" />
      </div>

      <div className="relative z-10 max-w-5xl w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-fuchsia-500 animate-pulse" />
            <span className="text-[10px] font-black uppercase tracking-[0.3em] text-zinc-300">
              Active Drop: Cyber Flora Series
            </span>
          </div>

          <h1 className="text-6xl sm:text-8xl lg:text-9xl font-black uppercase tracking-tighter leading-[0.85] mb-8 italic">
            Armored <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-500 to-cyan-400">
              Botanics
            </span>
          </h1>

          <div className="flex flex-col md:flex-row items-center justify-center gap-12 mt-12">
            <div className="text-left md:max-w-xs order-2 md:order-1">
              <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                Engineered for those who thrive in the intersection of digital chaos and natural order. Limited to 500 units per design.
              </p>
              <button className="group flex items-center gap-4 text-xs font-black uppercase tracking-widest text-white">
                <span className="w-12 h-[1px] bg-white group-hover:w-20 transition-all duration-500" />
                Explore Collection
              </button>
            </div>

            <div className="flex gap-4 order-1 md:order-2">
              {[timeLeft.h, timeLeft.m, timeLeft.s].map((unit, i) => (
                <div key={i} className="flex flex-col items-center">
                  <div className="w-16 h-20 sm:w-24 sm:h-28 glass-panel rounded-xl flex items-center justify-center relative overflow-hidden">
                    <span className="text-3xl sm:text-5xl font-black font-mono tracking-tighter">
                      {unit.toString().padStart(2, '0')}
                    </span>
                    <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-fuchsia-500 to-cyan-400 opacity-50" />
                  </div>
                  <span className="text-[9px] font-bold text-zinc-500 uppercase mt-3 tracking-widest">
                    {['Hours', 'Mins', 'Secs'][i]}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <span className="text-[9px] font-black uppercase tracking-[0.4em] text-zinc-500">Scroll</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-white/20 to-transparent" />
      </motion.div>
    </section>
  );
};

export default Hero;